import { useState, useEffect, useRef } from "react";
import magazine1 from "../../assets/images/inicio/revista cyn.png";
import magazine2 from "../../assets/images/inicio/revista met.png";
import magazine3 from "../../assets/images/inicio/revista idrasa.png";
// import magazine4 from "../../assets/images/inicio/revista cyn.png";
// import magazine5 from "../../assets/images/inicio/revista cyn.png";
import chevrontLeft from "../../assets/images/inicio/ooui_next-rtl.svg";
import chevrontRight from "../../assets/images/inicio/ooui_next-rtl(1).svg";

import "./Carousel.css";

const revistas = [
  { id: 1, src: magazine1, alt: "Revista 1" },
  { id: 2, src: magazine2, alt: "Revista 2" },
  { id: 3, src: magazine3, alt: "Revista 3" },
  // { id: 4, src: magazine4, alt: "Revista 4" },
  // { id: 5, src: magazine5, alt: "Revista 5" },
];

const Carousel = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const containerRef = useRef(null);

  // Cambiar visibleCount según el ancho del contenedor
  useEffect(() => {
    const updateVisibleCount = () => {
      if (!containerRef.current) return;
      const width = containerRef.current.offsetWidth;

      if (width < 480) setVisibleCount(1);
      else if (width < 768) setVisibleCount(2);
      else setVisibleCount(3);
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);

    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const handlePrev = () => {
    if (startIndex > 0) setStartIndex(startIndex - 1);
  };

  const handleNext = () => {
    if (startIndex + visibleCount < revistas.length)
      setStartIndex(startIndex + 1);
  };

  const revistasVisibles = revistas.slice(
    startIndex,
    startIndex + visibleCount
  );

  return (
    <div className="carousel-container" ref={containerRef}>
      <button
        className="carousel-button left"
        onClick={handlePrev}
        aria-label="Previous"
      >
        <img src={chevrontLeft} alt="Flecha Izquierda" loading="lazy" />
      </button>

      <div className="carousel-images">
        {revistasVisibles.map((revista) => (
          <img
            key={revista.id}
            src={revista.src}
            alt={revista.alt}
            className="carousel-image"
            loading="lazy"
          />
        ))}
      </div>

      <button
        className="carousel-button right"
        onClick={handleNext}
        aria-label="Next"
      >
        <img src={chevrontRight} alt="Flecha Izquierda" loading="lazy" />
      </button>
    </div>
  );
};

export default Carousel;
